import { cn } from "@/lib/utils";

// Elegant empty state / placeholder used for not-yet-shipped sections.
export function EmptyState({ Icon, title, description, action, className, testId }) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card/50 px-6 py-16 text-center",
        className,
      )}
      data-testid={testId || "empty-state"}
    >
      {Icon && (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-border bg-accent/40">
          <Icon size={22} weight="duotone" className="text-muted-foreground" />
        </div>
      )}
      <h3 className="text-lg font-medium tracking-tight">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
